import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  simpleForm: {
    position: "relative",
    "& .MuiCardContent-root": {
      padding: "0 !important",
    },
  },
  mapWrapper: {
    height: "85vh",
    width: "100%",
    backgroundColor: "#ffffff",
    overflowY: "auto",
    position: "relative",
  },
  backdropLoading: {
    zIndex: (theme as any).zIndex.tooltip + 1,
    color: "#FFFFFF",
    position: "absolute",
  },
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
}));

export { useStyles };
